import {
  ADD_PATIENTQUERY,
  GET_PATIENTQUERY,
  GET_ALLPATIENTQUERY,
  LOADING_PATIENTQUERY,
  STOP_LOADING_PATIENTQUERY,
  UPDATE_PATIENTQUERY,
} from "../types";

const initialState = {
  patientQueries: [],
  loading_state: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_PATIENTQUERY:
      return {
        ...state,
        patientQueries: [...state.patientQueries, action.payload],
        // loading_state: false
      };

    case GET_ALLPATIENTQUERY:
      return {
        ...state,
        patientQueries: action.payload.data,
        pendingPatientQueries: action.payload.data.filter(
          (query) => query.status === 1
        ),
        total: action.payload.total,
      };
    case LOADING_PATIENTQUERY:
      return {
        ...state,
        loading_state: true,
      };
    case STOP_LOADING_PATIENTQUERY:
      return {
        ...state,
        loading_state: false,
      };

    case UPDATE_PATIENTQUERY:
      let index = state.patientQueries.findIndex(
        (x) => x.id === action.payload.id
      );
      const updatedPatientQueries = [...state.patientQueries];
      updatedPatientQueries[index] = {
        ...updatedPatientQueries[index],
        ...action.payload,
      };
      return {
        ...state,
        directDebits: [...updatedPatientQueries],
        loading_state: false,
      };
    default:
      return state;
  }
}
